import { Col, Modal, Row, Typography } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import CheckBoxUC from '../../../components/Form/CheckBoxUC'
import ConsentDetail from './consentDetail'
import ButtonUC from '../../../components/buttonUC'
import pdfPDPA from '../../../assets/files/pdpa.pdf'
import { consentDatas } from './constant'
import PDFViewer from './PDFViewer';


const Consent = ({ props }) => {

    const { Text } = Typography
    const checkLabel1 = 'ข้าพเจ้าเป็นผู้มีคุณสมบัติเฉพาะตำแหน่งตามประกาศรับสมัครและคุณสมบัติทั่วไปครบถ้วนตามที่กำหนดไว้ในข้อ 16 แห่งระเบียบสภากาชาดไทย ว่าด้วยการบริหารงานทรัพยากรบุคคล พ.ศ. 2567'
    const [openModalConsent, setOpenModalConsent] = useState(false)
    const { form } = props
    const [isReadConsent, setIsReadConsent] = useState(false)

    const [openModalApprove, setOpenModalApprove] = useState(false)

    const divModalRef = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(false);
    const [scale, setScale] = useState(1.0); // Initial zoom level
    const isDraft = form.getFieldValue().isDraft ?? true

    useEffect(() => {
        const handleScroll = () => {
            if (divModalRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = divModalRef.current;
                if (scrollHeight - scrollTop <= clientHeight + 1) {
                    setIsAtBottom(true)
                }
            }
        };
        const currentContainer = divModalRef.current;
        if (currentContainer) {
            currentContainer.addEventListener('scroll', handleScroll);
            currentContainer.scrollTop = 0; // default 1st page
            setScale(1) // set scale to 100% by default
        }

        return () => {
            setIsAtBottom(false)
            if (currentContainer) {
                currentContainer.removeEventListener('scroll', handleScroll);
            }
        };
    }, [openModalApprove]);

    const checkAll = () => {
        const valCheckBox = form.getFieldsValue().isAll
        form.setFieldsValue({
            isDrug: valCheckBox,
            isHealth: valCheckBox,
            isRelegion: valCheckBox,
            isBio: valCheckBox,
            isCriminal: valCheckBox,
            isExternalData: valCheckBox,
        })
    }

    const checkSomeVal = () => {
        const valCheckBoxAll = form.getFieldsValue().isAll
        if (valCheckBoxAll === true) {
            form.setFieldValue('isAll', false)
        }
    }

    const modalApprove = (eventData) => {
        const userId = form.getFieldValue().id
        const isOpenConsent = userId || isReadConsent

        if (!isOpenConsent) {
            setOpenModalApprove(true)
        }
    }

    const handlAcceptConsent = () => {
        setOpenModalApprove(false)
        setIsReadConsent(true)
        form.setFieldValue("isPDPA", true)
    }

    const cancelAcceptConsent = () => {
        const userId = form.getFieldValue().id
        const isOpenConsent = userId || isReadConsent
        if (isOpenConsent) {
            setOpenModalApprove(false)
        } else {
            setOpenModalApprove(false)
            form.setFieldValue("isPDPA", false)
        }
    }

    const increaseZoom = () => {
        setScale(prevScale => Math.min(prevScale + 0.25, 3.0)); // Max zoom level is 3.0
    };

    const decreaseZoom = () => {
        setScale(prevScale => Math.max(prevScale - 0.25, 0.5)); // Min zoom level is 0.5
    };

    const normalZoom = () => {
        setScale(1);
    };

    const headStyles = {
        border: "1px solid #dddddd",
        padding: "8px"
    }

    return (
        <>
            <div className="consent content-block p-3">
                <div className="block-title">ข้อตกลง</div>
                <Row className="isTermsAndConds py-4">
                    <Col span={24} className='px-2 div-checkbox-isTermsAndConds'>
                        <CheckBoxUC required={true} className="check-isTermsAndConds" label={checkLabel1} name={'isTermsAndConds'} isShowHead={false} />
                    </Col>
                    <Col className='mt-4 px-2'>
                        <div>ผู้ที่จะได้รับการบรรจุ (จ้าง) เป็นบุคลากรสภากาชาดไทย ต้องเป็นผู้ที่เลื่อมใสในการปกครองระบอบประชาธิปไตยอันมีพระมหากษัตริย์เป็นประมุข และต้องมีคุณสมบัติทั่วไป และไม่มีลักษณะต้องห้ามดังต่อไปนี้</div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className='px-2 div-checkbox-isTermsAndConds' >
                        <div >(ก) คุณสมบัติทั่วไป</div>
                        <div style={{ marginLeft: '10px', marginBottom: '10px', marginTop: '8px' }}>
                            <div>1. มีอายุไม่ต่ำกว่า 18 ปีบริบูรณ์ สำหรับชายต้องปลดพันธะทางทหารประจำการมาแล้วหรือทหารกองหนุน ยกเว้นผู้สำเร็จการศึกษาจากสถาบันการศึกษาของสภากาชาดไทย </div>
                            <div>2. สามารถทำงานให้แก่หน่วยงานได้เต็มเวลา หรือตามที่ระบุในสัญญาจ้าง</div>
                            <div>3. มีคุณวุฒิหรือประสบการณ์เหมาะสมกับหน้าที่และวัตถุประสงค์ของหน่วยงาน รวมทั้งเหมาะสมกับงานเฉพาะนั้น ๆ </div>
                        </div>
                        <div>(ข) ลักษณะต้องห้าม</div>
                        <div style={{ marginLeft: '10px', marginBottom: '6px', marginTop: '8px' }}>
                            <div>1. เป็นผู้มีกายทุพพลภาพจนไม่สามารถปฏิบัติหน้าที่ได้ คนไร้ความสามารถ คนเสมือนไร้ความสามารถ หรือจิตฟั่นเฟือนไม่สมประกอบ</div>
                            <div>2. เป็นบุคคลล้มละลาย</div>
                            <div>3. เป็นผู้เคยต้องรับโทษจำคุกโดยคำพิพากษาถึงที่สุดให้จำคุก เพราะกระทำความผิดทางอาญา เว้นแต่เป็นโทษสำหรับความผิดที่ได้กระทำโดยประมาทหรือความผิดลหุโทษ</div>
                            <div>4. เป็นผู้ดำรงตำแหน่งทางการเมือง สมาชิกสภาท้องถิ่น หรือผู้บริหารท้องถิ่น หรือเป็นกรรมการ ผู้ดำรงตำแหน่งที่รับผิดชอบในการบริหาร ที่ปรึกษา เจ้าหน้าที่ หรือผู้มีตำแหน่งอื่นใดของพรรคการเมือง</div>
                            <div>5. เป็นผู้เคยถูกลงโทษให้ออก ปลดออก หรือไล่ออกเพราะกระทำผิดวินัยจากหน่วยงานราชการ รัฐวิสาหกิจ องค์การมหาชน หน่วยงานอื่นของรัฐ หน่วยงานเอกชน หรือหน่วยงานต่าง ๆ ของสภากาชาดไทย</div>
                        </div>
                        <div>(ค) โรคต้องห้าม</div>
                        <div style={{ marginLeft: '10px', marginBottom: '6px', marginTop: '8px' }}>
                            <div>1. โรคติดต่อร้ายแรงหรือโรคเรื้อรังที่ปรากฎอาการเด่นชัดหรือรุนแรง และเป็นอุปสรรคต่อการปฏิบัติงาน</div>
                            <div>2. วัณโรคในระยะอันตราย (แพร่กระจายเชื้อ)</div>
                            <div>3. โรคเท้าช้างในระยะที่ปรากฎอาการเป็นที่รังเกียจแก่สังคม</div>
                            <div>4. โรคติดยาเสพติดให้โทษ</div>
                            <div>5. โรคพิษสุราเรื้อรัง</div>
                        </div>
                        <div style={{ marginBottom: '6px', marginTop: '8px' }}>
                            <div>ข้าพเจ้าขอรับรองว่าข้อความทั้งหมดที่ให้ไว้ในใบสมัครฉบับนี้ถูกต้องครบถ้วนและเป็นความจริงทุกประการ หากภายหลังมีการตรวจสอบพบว่าข้าพเจ้าปกปิดข้อมูลประวัติการดำเนินคดีหรือประวัติอาชญากรรมหรือเป็นผู้ขาดคุณสมบัติข้อใดข้อหนึ่งแล้วรวมถึงใช้วุฒิการศึกษาที่ไม่ตรงตามที่สมัครไว้ ข้าพเจ้ายินดีให้ทางสภากาชาดไทยดำเนินการให้ออกเพราะสาเหตุขาดคุณสมบัติต่อไป</div>
                        </div>
                    </Col>
                </Row>
                {/* <Row>
                    <Col span={24} className='ml-8 pr-12 mt-4'>
                        <div>ข้าพเจ้าขอรับรองว่าข้อความทั้งหมดที่ให้ไว้ในใบสมัครฉบับนี้ถูกต้องครบถ้วนและเป็นความจริงทุกประการหากภายหลังมีการตรวจสอบพบว่าข้าพเจ้าเป็นผู้ขาดคุณสมบัติข้อใดข้อหนึ่งแล้วรวมถึงการใช้วุฒิการศึกษาที่ไม่ตรงตามที่สมัครงานไว้ข้าพเจ้ายินดีให้ทางสภากาชาดไทยดำเนินการให้ออกเพราะสาเหตุขาดคุณสมบัติต่อไป</div>
                    </Col>
                </Row> */}
                <Row className='mt-4 px-2'>
                    <Col span={24} style={{ marginBottom: '6px' }}>
                        <Text className='color-secondary1 consent-title'>หนังสือยินยอม</Text>
                    </Col>
                </Row>

                <Row className="isPDPA py-4">
                    <Col span={24} className='px-2 div-checkbox-isPDPA'>
                        {/* label='เงื่อนไขและข้อกำหนด'  */}
                        <Row style={{ display: "flex", alignItems: "center" }}>
                            <CheckBoxUC required={true} className="check-isPDPA" style={{ marginRight: "10px" }} name={'isPDPA'} isShowHead={false} onChange={modalApprove} />
                            <Text className='color-info underline cursor-pointer' style={{ marginInline: "10px" }} onClick={() => setOpenModalApprove(true)}>เงื่อนไขและข้อกำหนด</Text>
                            <Text style={{ color: "#6B7280" }}>(กรุณาอ่านเงื่อนไขและข้อกำหนดเพื่อยินยอม)</Text>
                        </Row>
                    </Col>
                </Row>
                <Row className="py-4">
                    <Col span={24} className='px-2'>
                        <Row style={{ display: "flex", alignItems: "center" }}>
                            <Col>
                                <span>ข้าพเจ้ายินยอมให้ สภากาชาดไทยประมวลผลข้อมูลส่วนบุคคลของข้าพเจ้า เพื่อวัตถุประสงค์ตามที่ข้าพเจ้า ได้ทำเครื่องหมาย</span>
                            </Col>
                            <Col style={{ margin: "0px 5px 0px 5px" }}><CheckBoxUC checked={true} /></Col>
                            <Col><div>ไว้</div></Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="py-4">
                    <Col span={24} className='px-2'>
                        <table>
                            <thead>
                                <tr >
                                    <th style={headStyles}></th>
                                    <th style={headStyles}>วัตถุประสงค์หลัก</th>
                                    <th style={headStyles}>รายละเอียดวัตถุประสงค์หลัก</th>
                                    <th style={headStyles}>ยินยอม</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    consentDatas.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td style={headStyles}>{index + 1}.</td>
                                                <td style={headStyles} colSpan={index === 6 ? "2" : "1"}>{item.title}</td>
                                                {index === 6 ? [] : <td style={headStyles}>{item.details}</td>}
                                                <td style={{ border: "1px solid #dddddd", padding: "8px", textAlignLast: "center" }}>
                                                    <CheckBoxUC
                                                        required={false}
                                                        name={item.name}
                                                        isShowHead={false}
                                                        disabled={!isDraft}
                                                        onChange={() => index === 6 ? checkAll() : checkSomeVal()}
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <Row className="py-4">
                    <Col span={24} className='px-2'>
                        <div>
                            * หมายเหตุ : ในกรณีที่เจ้าของข้อมูลไม่ให้ความยินยอมในการประมวลผลข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ตามข้อใดข้อหนึ่งข้างต้น
                            สภากาชาดไทยจะไม่สามารถประมวลผลข้อมูลส่วนบุคคลของเจ้าของข้อมูลเพื่อวัตถุประสงค์ตามข้อนั้นได้ ด้วยเหตุนี้เจ้าของข้อมูลส่วนบุคคลอาจจะไม่ได้รับสิทธิประโยชน์ต่าง ๆ
                            จากสภากาชาดไทยหรือไม่สามารถเข้าทำธุรกรรมอย่างใดอย่างหนึ่งกับสภากาชาดไทยได้ หากสภากาชาดไทยจำเป็นต้องประมวลผลข้อมูลส่วนบุคคลดังกล่าวเพื่อดำเนินการเกี่ยวกับวัตถุประสงค์ที่เจ้าของข้อมูลไม่ยินยอมนั้น
                        </div>
                    </Col>
                </Row>
                <Row className="py-4">
                    <Col span={24} className='px-2'>
                        <div>
                            ข้าพเจ้าได้อ่านและเข้าใจถึงการใช้ข้อมูลส่วนบุคคลของข้าพเจ้าตามที่ระบุไว้ในหนังสือยินยอมฉบับนี้และได้ลงนามด้วยความสมัครใจ โดยทราบถึงสิทธิในการให้หรือปฏิเสธที่จะให้ความยินยอม รวมถึงสิทธิในการเพิกถอนภายหลัง ทั้งนี้ ข้าพเจ้าตกลงให้สําเนาภาพถ่าย หรือการบันทึกในรูปแบบใด ๆ มีผลเป็นหลักฐานยืนยันถึงการให้ความยินยอมของข้าพเจ้าเช่นเดียวกัน
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal
                centered
                footer={false}
                open={openModalConsent}
                closable={false}
            // onOk={false}
            // onCancel={() => setOpenModalConsent(false)}
            // width='60%'
            >
                <div className="div-modal-content">
                    <ConsentDetail />
                    <Row className="justify-center items-center pt-6">
                        <ButtonUC
                            style={{ width: '170px' }}
                            className='btn-clear'
                            onClick={() => setOpenModalConsent(false)}>ปิด</ButtonUC>
                    </Row>
                </div>
            </Modal>
            <Modal
                centered
                footer={false}
                open={openModalApprove}
                closable={true}
                // onOk={false}
                onCancel={() => cancelAcceptConsent()}
                width='80%'
                height="auto"
            >
                <>
                    <div className="zoom-controls text-center mb-3" >
                        <button className='btn-clear mr-4' onClick={decreaseZoom}>-</button>
                        <button className='btn-clear mr-4' onClick={increaseZoom}>+</button>
                        <button className='btn-clear btn-normal-zoom' onClick={normalZoom}>100%</button>
                    </div>
                    <div className="div-modal-content" >
                        <div className='pdf-content' ref={divModalRef} style={{
                            height: "calc(100vh - 245px)", overflow: "auto",
                            transition: 'scrollbar-width 0.3s ease-out'
                        }}>
                            <PDFViewer url={pdfPDPA} scale={scale} />
                        </div>
                    </div>
                </>
                <Row className="justify-center items-center pt-6" style={{ position: "sticky", bottom: "0", backgroundColor: "white" }}>
                    <ButtonUC
                        disabled={!isAtBottom}
                        style={{ width: '170px' }}
                        onClick={() => handlAcceptConsent()}>ยินยอม</ButtonUC>
                </Row>
            </Modal >
        </>
    )
}

export default Consent